import React, { useEffect, useState,useContext } from 'react';
import {
  Text,
  Modal,
  useResponsiveParams,
  MixedTabbedDataGroup,
  SearchResultsAdvanced,
  QuantaFormik,
  QuantaForm,
  Paper,
  Grid,
  GridItem,
  InputGridGroup,
  Button,
  useQuantaFormikContext,
} from 'quanta-ui';
import {
  faBuilding,
  faEnvelope,
  faExclamationCircle,
  faExclamationTriangle,
  faMapMarkerAlt,
  faMobileAlt,
  faSave,
  faSearch,
  faTimesCircle,
  faUniversity,
  faUser,
  faUserCheck,
  faUserPlus,
  faUserTag,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  CHARACTER_LIMIT_LIST,
  CUSTOMER_DROPDOWN_DETAILS,
  GET_CUSTOMER_TYPE_DOMAIN,
  MOBILE_NUMBER_STARTING_WITH,
  SAVE_QUOTE_FIRE,
  SAVE_LOCATION_FIRE,
  SEARCH_CUSTOMERS,
} from '../../queries';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
// import useFetchQuery from '../../../../../../lib/graphql/useFetchQuery';
import { useFetchQuery } from 'quanta-flows';
// import IconIdle from '../../../../../common/icon-search-idle';
// import { IconIdle } from 'quanta-flows';
// import { Error, Loading } from '../../../../../../lib/layout';
import { Error,Loading } from 'quanta-flows/modules/layout';
// import {
//   updateFireQuote,
//   updateFireQuoteUploadDocsVar,
// } from '../../_graphql/state';
import { updateFireQuote, updateFireQuoteUploadDocsVar} from 'quanta-flows/modules/quote/fire/state';
import moment from 'moment';
import {QuantaConfigContext} from'quanta-flows';
import { useMutationQuery } from 'quanta-flows';
import { v4 as uuidv4 } from 'uuid';

const getDomainData = (
  domainArr,
  searchText,
  searchType,
  returnType,
) => {
  return domainArr?.find(
    (d) =>
      d[`${searchType}`]?.toString()?.toLowerCase() ===
      searchText?.toString()?.toLowerCase(),
  )
    ? domainArr.find(
        (d) =>
          d[`${searchType}`]?.toString()?.toLowerCase() ===
          searchText?.toString()?.toLowerCase(),
      )[`${returnType}`]
    : '';
};

const reformData = (val, returnType, isString) => {
  return val && val.toString().trim() !== ''
    ? isString === undefined || isString === true
      ? `${val}`
      : val
    : returnType;
};

const saveQuoteVariables = ({
  getDefaultClauses,
  getDefaultConditions,
  getDefaultWarranties,
  getDefaultExclusions,
  values,
  customer,
  fireQuote,
  selectedIntermediary,
  lobCode,
  productCode,
}) => {
  return {
    input: {
      quoteNumber: fireQuote?.quoteNumber
        ? `${fireQuote?.quoteNumber}`
        : '',
      locationCode:fireQuote?.locationCode.toString(),
      eqZone: fireQuote?.eqZone.toString(),
      pinCodeLocality: fireQuote?.pinCodeLocality.toString(),
      city: fireQuote?.city.toString(),
      quoteCreationDate: fireQuote?.quoteCreationDate
        ? `${fireQuote?.quoteCreationDate}`
        : '',
      intermediary: {
        intermediaryCode: fireQuote?.intermediaryDetails?.code
          ? fireQuote?.intermediaryDetails?.code
          : selectedIntermediary?.intermediaryCode
            ? `${selectedIntermediary?.intermediaryCode}`
            : '',
        locationCode: selectedIntermediary?.branchOfficeCode
          ? `${selectedIntermediary?.branchOfficeCode}`
          : '',
        fieldUserCode: selectedIntermediary?.fieldUserCode
          ? `${selectedIntermediary?.fieldUserCode}`
          : '',
      },
      lob: lobCode,
      product: productCode,
      productName: fireQuote?.productKg,
      basisOfValuation: fireQuote?.basisOfValuation,
      otherDetails:{
        premisesRentedOut:fireQuote?.otherDetails?.premisesRentedOut,
        ownerOccupant: fireQuote?.otherDetails?.ownerOccupant,
      },
      loadingAndDiscount: {
        discountPercentage:parseFloat(fireQuote?.loadingAndDiscount?.discountPercentage),
        loadingPercentage: parseFloat(fireQuote?.loadingAndDiscount?.loadingPercentage),
      },
      district:fireQuote?.district
      ? `${fireQuote?.district}`
        : '',
        pincode: fireQuote?.pincode
        ? `${fireQuote?.pincode}`
          : '',
        state:fireQuote?.state
        ? `${fireQuote?.state}`
          : '',
        customerDetails:
          {
            customerType:{
            code : fireQuote?.customerDetails?.customerType?.code,
            value : fireQuote?.customerDetails?.customerType?.value,
            },
            orgInsuredName : fireQuote?.customerDetails?.orgInsuredName,
            firstName : fireQuote?.customerDetails?.firstName,
            middleName : fireQuote?.customerDetails?.middleName,
            lastName: fireQuote?.customerDetails?.lastName,
          },
      customer,
      riskCovers: fireQuote?.riskcoverdata
        ? fireQuote?.riskcoverdata
        : [],
      ratePerMille: fireQuote?.riskcoverdata
        ?.find(
          (risk) => risk?.riskType === 'Cover Fire SA',
        )
        ?.covers?.map((cov) =>
          cov?.name === 'Basic Fire Cover'
            ? cov?.basicRate
            : 0,
        )
        // ?.filter((d: any) => d),
        ?.filter((d) => d)?.[0],
      businessOfInsured: fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.businessOfInsured,
      anyPrevClaimsExp: fireQuote?.tabDetails?.customerTabDetails?.previousClaimExperienceDetails?.isClaimMadeInPreviousYears?.toString()?.toLowerCase() === 'yes' ? true: false,
      prevClaimExpDesc: fireQuote?.tabDetails?.customerTabDetails?.previousClaimExperienceDetails?.isClaimMadeInPreviousYears?.toString()?.toLowerCase() === 'yes' && fireQuote?.tabDetails?.customerTabDetails?.previousClaimExperienceDetails?.claimInPreviousYearsInfo ? fireQuote?.tabDetails?.customerTabDetails?.previousClaimExperienceDetails?.claimInPreviousYearsInfo: '',
      isKutchaConstruct: fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.isInsuranceForKutchaConstruction?.toString()?.toLowerCase() === 'yes' ? true: false,
      policyType: fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.code,
      tenure: fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.tenure?.code,
      policyStartDate: fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyStartDate,
      stageIndex: 3,
      finalisedPremium: {
        locNetPremium: fireQuote?.finalisedPremium?.locationNetPremium,
        locGST: fireQuote?.finalisedPremium?.locationGST,
        locTotalPremium: fireQuote?.finalisedPremium?.locationTotalPremium,
        basicRate:fireQuote?.finalisedPremium?.basicRate
        || fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.locationPremium?.basicRate
        // stampDuty: fireQuote?.finalisedPremium?.stampDuty
      },
      clauses: {
        ClauseCode:getDefaultClauses?.map(
          (clause) => clause?.clauseCode,
        )
          ? getDefaultClauses?.map(
              (clause) => clause?.clauseCode,
            )
          : [],
          ClauseNumber:getDefaultClauses?.map(
            (clause) => clause?.clauseNumber,
          )
            ? getDefaultClauses?.map(
                (clause) => clause?.clauseNumber,
              )
            : [],
        Description:getDefaultClauses?.map(
            (clause) => clause?.default,
          )
            ? getDefaultClauses?.map(
                (clause) => clause?.default,
              )
            : [],
        default: getDefaultClauses?.map(
          (clause) => clause?.clauseDescription,
        )
          ? getDefaultClauses?.map(
              (clause) => clause?.clauseDescription,
            )
          : [],
        userDefined: values?.userDefinedClauses
          ?.filter((udc) => udc?.clause)
          ?.map((udc) => udc?.clause),
      },
      warranties: {
        WarrantyCode:getDefaultWarranties?.map(
          (warranty) => warranty?.warrantyCode,
        )
          ? getDefaultWarranties?.map(
              (warranty) => warranty?.warrantyCode,
            )
          : [],
        default: getDefaultWarranties?.map(
          (warranty) => warranty?.warrantyShortDescription,
        )
          ? getDefaultWarranties?.map(
              (warranty) => warranty?.warrantyShortDescription,
            )
          : [],
        WarrantyNumber:getDefaultWarranties?.map(
          (warranty) => warranty?.txtWarrantyNumber,
        )
          ? getDefaultWarranties?.map(
              (warranty) => warranty?.txtWarrantyNumber,
            )
          : [],
        Description:getDefaultWarranties?.map(
          (warranty) => warranty?.txtDefault,
        )
          ? getDefaultWarranties?.map(
              (warranty) => warranty?.txtDefault,
            )
          : [],
        userDefined: values?.userDefinedWarranties
          ?.filter((udw) => udw?.warranty)
          ?.map((udw) => udw?.warranty),
      },
      exclusions: {
        ExclusionCode:getDefaultExclusions?.map(
          (exclusion) => exclusion?.exclusionCode,
        )
          ? getDefaultExclusions?.map(
              (exclusion) => exclusion?.exclusionCode,
            )
          : [],
          ExclusionNumber:getDefaultExclusions?.map(
            (exclusion) => exclusion?.txtExclusionNumber,
          )
            ? getDefaultExclusions?.map(
                (exclusion) => exclusion?.txtExclusionNumber,
              )
          : [],
        Description:getDefaultExclusions?.map(
            (exclusion) => exclusion?.txtDefault,
          )
            ? getDefaultExclusions?.map(
                (exclusion) => exclusion?.txtDefault,
              )
            : [],
        default: getDefaultExclusions?.map(
          (exclusion) => exclusion?.exclusionShortDescription,
        )
          ? getDefaultExclusions?.map(
              (exclusion) => exclusion?.exclusionShortDescription,
            )
          : [],
        userDefined: values?.userDefinedExclusions
          ?.filter((ude) => ude?.exclusion)
          ?.map((ude) => ude?.exclusion),
      },
      conditions: {
        ConditionCode:getDefaultConditions?.map(
          (condition) => condition?.conditionCode,
        )
          ? getDefaultConditions?.map(
              (condition) => condition?.conditionCode,
            )
          : [],
          ConditionNumber:getDefaultConditions?.map(
            (condition) => condition?.txtConditionNumber,
          )
            ? getDefaultConditions?.map(
                (condition) => condition?.txtConditionNumber,
              )
          : [],
        Description:getDefaultConditions?.map(
            (condition) => condition?.txtDefault,
          )
            ? getDefaultConditions?.map(
                (condition) => condition?.txtDefault,
              )
            : [],
        default: getDefaultConditions?.map(
          (condition) => condition?.conditionShortDescription,
        )
          ? getDefaultConditions?.map(
              (condition) => condition?.conditionShortDescription,
            )
          : [],
        userDefined: values?.userDefinedConditions
          ?.filter((udc) => udc?.condition)
          ?.map((udc) => udc?.condition),
      },
      Manualccxw:  (values?.userDefinedClauses[0]?.clause !== "" ||
      values?.userDefinedConditions[0]?.condition !== "" ||
      values?.userDefinedExclusions[0]?.exclusion !== "" ||
      values?.userDefinedWarranties[0]?.warranty !== "" ) ? 'True'
                  : 'False',
      occupancyCode: fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.code=='Floater'
      ?fireQuote?.tabDetails?.riskLocationTabDetails?.floaterType?.occupancy?.code
      :fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType[0]?.occupancy?.code,
      Max_Loading:fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.code=='Floater'
      ?fireQuote?.tabDetails?.riskLocationTabDetails?.floaterType?.loadingAndDiscount?.loadingPercentage
      :fireQuote?.loadingAndDiscount?.loadingPercentage?.toString(),
      Max_Discount:fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.code=='Floater'
      ?fireQuote?.tabDetails?.riskLocationTabDetails?.floaterType?.loadingAndDiscount?.discountPercentage
      :fireQuote?.loadingAndDiscount?.discountPercentage?.toString()      ,
      Max_Content_SI:fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.code=='Floater'
      ?fireQuote?.tabDetails?.riskLocationTabDetails?.floaterType?.riskSumInsured?.maximumStockSIAtOneLocation
      :fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.valuableContentSI?.toString(),
      Max_Policy_SI: fireQuote?.tabDetails.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.code === 'Home Building And Home Contents Only'
        ? fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.totalSumInsured?.toString()
        : fireQuote?.tabDetails.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.code === 'Home Building Only'
          ? fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.totalBuildingSI?.toString()
          : fireQuote?.tabDetails.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.code === 'Home Contents Only'
            ? fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.totalContentSI?.toString()
            : fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.totalSumInsured
      ,
      carpetArea:fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured
      ?.carpetArea,
      costOfConstruction:fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.costOfConstruction,
      additionalContent:
        fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock
          ?.additionalContent,
      additionalContentSI:
        parseFloat(fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock
          ?.additionalContentSI),
      valuableContent:
        fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock
          ?.valuableContent,
      valuableContentSI:
        parseFloat(fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock
          ?.valuableContentSI),
      TotalBuildingSI:fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured
      ?.totalBuildingSI,
      Additional_living_expenses:fireQuote?.tabDetails?.riskLocationTabDetails
      ?.addOnCovers?.['Additional Living Expenses']
      ?.selected
      ?fireQuote?.tabDetails?.riskLocationTabDetails?.addOnCovers?.['Additional Living Expenses']
      ?.attributes?.additionalLivingExpensesSI?.toString()
      :'',
      Loss_Minimization_Expenses:fireQuote?.tabDetails?.riskLocationTabDetails
      ?.addOnCovers?.['Loss Minimization Expenses']
      ?.selected
      ?fireQuote?.tabDetails?.riskLocationTabDetails?.addOnCovers?.['Loss Minimization Expenses']
      ?.attributes?.lossMinimizationExpensesSI?.toString()
      :'',
      Involuntary_Betterment_Technological_Advancement:fireQuote?.tabDetails?.riskLocationTabDetails
      ?.addOnCovers?.['Involuntary Betterment Technological Advancement']
      ?.selected
      ?fireQuote?.tabDetails?.riskLocationTabDetails?.addOnCovers?.['Involuntary Betterment Technological Advancement']
      ?.attributes?.involuntaryBettermentTechnologicalAdvancementSI?.toString()
      :'',
      Specified_Incidental_Expenses_Cover:fireQuote?.tabDetails?.riskLocationTabDetails
      ?.addOnCovers?.['Specified Incidental Expenses Cover']
      ?.selected
      ?fireQuote?.tabDetails?.riskLocationTabDetails?.addOnCovers?.['Specified Incidental Expenses Cover']
      ?.attributes?.specifiedIncidentalExpensesCoverSI?.toString()
      :'',
      LossofRent:fireQuote?.tabDetails?.riskLocationTabDetails
      ?.addOnCovers?.['Loss of Rent']
      ?.selected
      ?fireQuote?.tabDetails?.riskLocationTabDetails?.addOnCovers?.['Loss of Rent']
      ?.attributes?.Indemnity_Period_Loss_of_Rent_In_Months?.toString()
      :'',
      Alternative_Accommodation:fireQuote?.tabDetails?.riskLocationTabDetails
      ?.addOnCovers?.['Rent for an Alternative Accommodation']
      ?.selected
      ?fireQuote?.tabDetails?.riskLocationTabDetails?.addOnCovers?.['Rent for an Alternative Accommodation']
          ?.attributes?.accomodationIndemnityPeriodInMonths?.toString()
      :'',
      // /////////////////////////////////////CR090 
      Personal_Accident_For_Self: fireQuote?.tabDetails?.riskLocationTabDetails
        ?.addOnCovers?.['Personal Accident Cover Self']
        ?.selected
        ? fireQuote?.tabDetails?.riskLocationTabDetails?.addOnCovers?.['Personal Accident Cover Self']
          ?.attributes?.personalAccidentCoverSelfSI?.toString()
        : '',
      Personal_Accident_For_Spouse: fireQuote?.tabDetails?.riskLocationTabDetails
        ?.addOnCovers?.['Personal Accident Cover Spouse']
        ?.selected
        ? fireQuote?.tabDetails?.riskLocationTabDetails?.addOnCovers?.['Personal Accident Cover Spouse']
          ?.attributes?.personalAccidentCoverSpouseSI?.toString()
        : '',
      Valuable_Cont_On_Agreed_Value_Basis: fireQuote?.tabDetails?.riskLocationTabDetails
        ?.addOnCovers?.['Cover for Valuable Contents on Agreed Value Basis']
        ?.selected
        ? fireQuote?.tabDetails?.riskLocationTabDetails?.addOnCovers?.['Cover for Valuable Contents on Agreed Value Basis']
          ?.attributes?.valContentsAgreedValBasisSI?.toString()
        : '', //Added new
      Architect_And_Surveyor_Fees: fireQuote?.tabDetails?.riskLocationTabDetails
        ?.addOnCovers?.['Architect and Surveyor Fees']
        ?.selected
        ? fireQuote?.tabDetails?.riskLocationTabDetails?.addOnCovers?.['Architect and Surveyor Fees']
          ?.attributes?.architectAndSurvSI?.toString()
        : '', /////////////////////
      Agreed_Value_Basis_Clause: fireQuote?.tabDetails?.riskLocationTabDetails
        ?.addOnCovers?.['Agreed Value Basis Clause']
        ?.selected
        ? fireQuote?.tabDetails?.riskLocationTabDetails?.addOnCovers?.['Agreed Value Basis Clause']
          ?.attributes?.agrValBasisClauseSI?.toString()
        : '',
      Landscaping_Expenses: fireQuote?.tabDetails?.riskLocationTabDetails
        ?.addOnCovers?.['Landscaping Expenses']
        ?.selected
        ? fireQuote?.tabDetails?.riskLocationTabDetails?.addOnCovers?.['Landscaping Expenses']
          ?.attributes?.landscapingExpensesSI?.toString()
        : '',
      Accidental_Damage: fireQuote?.tabDetails?.riskLocationTabDetails
        ?.addOnCovers?.['Accidental Damage']
        ?.selected
        ? fireQuote?.tabDetails?.riskLocationTabDetails?.addOnCovers?.['Accidental Damage']
          ?.attributes?.accidentalDamageSI?.toString()
        : '',
      Incidental_Expenses: fireQuote?.tabDetails?.riskLocationTabDetails
        ?.addOnCovers?.['Incidental Expenses']
        ?.selected
        ? fireQuote?.tabDetails?.riskLocationTabDetails?.addOnCovers?.['Incidental Expenses']
          ?.attributes?.incidentalExpensesSI?.toString()
        : '',
      Personal_Accident: fireQuote?.tabDetails?.riskLocationTabDetails
        ?.addOnCovers?.['Personal Accident Cover']
        ?.selected
        ? fireQuote?.tabDetails?.riskLocationTabDetails?.addOnCovers?.['Personal Accident Cover']
          ?.attributes?.personalAccidentSI?.toString()
        : '',
      Smoke_Damage: fireQuote?.tabDetails?.riskLocationTabDetails
        ?.addOnCovers?.['Smoke Damage']
        ?.selected
        ? fireQuote?.tabDetails?.riskLocationTabDetails?.addOnCovers?.['Smoke Damage']
          ?.attributes?.smokeDamageSI?.toString()
        : '',
      Removal_Of_Debries: fireQuote?.tabDetails?.riskLocationTabDetails
        ?.addOnCovers?.['Removal of Debris']
        ?.selected
        ? fireQuote?.tabDetails?.riskLocationTabDetails?.addOnCovers?.['Removal of Debris']
          ?.attributes?.removalOfDebriesSI?.toString()
        : '',
      Broad_Water_Damage: fireQuote?.tabDetails?.riskLocationTabDetails
        ?.addOnCovers?.['Broad Water Damage']
        ?.selected
        ? fireQuote?.tabDetails?.riskLocationTabDetails?.addOnCovers?.['Broad Water Damage']
          ?.attributes?.broadWaterDamageSI?.toString()
        : '',
      Tenant_Liability: fireQuote?.tabDetails?.riskLocationTabDetails
        ?.addOnCovers?.['Tenants Liability']
        ?.selected
        ? fireQuote?.tabDetails?.riskLocationTabDetails?.addOnCovers?.['Tenants Liability']
          ?.attributes?.tenantLiabilitySI?.toString()
        : '',
      Riots_Strikes: fireQuote?.tabDetails?.riskLocationTabDetails
        ?.addOnCovers?.['Riot, Strikes, Malicious Damages']
        ?.selected
        ? fireQuote?.tabDetails?.riskLocationTabDetails?.addOnCovers?.['Riot, Strikes, Malicious Damages']
          ?.attributes?.riotsStrikesSI?.toString()
        : '',
      STFI: fireQuote?.tabDetails?.riskLocationTabDetails
        ?.addOnCovers?.['STFI']
        ?.selected
        ? fireQuote?.tabDetails?.riskLocationTabDetails?.addOnCovers?.['STFI']
          ?.attributes?.stfiSI?.toString()
        : '',
      Loss_Of_Rent: fireQuote?.tabDetails?.riskLocationTabDetails
        ?.addOnCovers?.['Loss of Rent']
        ?.selected
        ? fireQuote?.tabDetails?.riskLocationTabDetails?.addOnCovers?.['Loss of Rent']
          ?.attributes?.lossOfRentSI?.toString()
        : '',
      Rent_For_Alternative_Accomodation: fireQuote?.tabDetails?.riskLocationTabDetails
        ?.addOnCovers?.['Rent for an Alternative Accommodation']
        ?.selected
        ? fireQuote?.tabDetails?.riskLocationTabDetails?.addOnCovers?.['Rent for an Alternative Accommodation']
          ?.attributes?.rentForAlternativeAccommodationSI?.toString()
        : '',
      Tot_Sum_Insured: fireQuote?.tabDetails.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.code === 'Home Building And Home Contents Only'
        ? fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.totalSumInsured
        : fireQuote?.tabDetails.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.code === 'Home Building Only'
          ? fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.totalBuildingSI
          : fireQuote?.tabDetails.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.code === 'Home Contents Only'
            ? fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.totalContentSI
            : fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.totalSumInsured
      ,
      Contents_SI: fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.totalContentSI,
      Buildings_SI: fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.totalBuildingSI,
      // fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.totalBuildingSI : ,
      uploadDocuments: values?.documentDetails
        ?.filter(
          (document) =>
            document?.documentName && document?.documentBase64String,
        )
        ?.map((document) => {
          return {
            documentType: {
              code: document?.documentName
                ? `${document?.documentName}`
                : '',
              value: document?.documentNameValue
                ? `${document?.documentNameValue}`
                : '',
            },
            documentName: document?.documentFileNameWithExtension
              ? `${document?.documentFileNameWithExtension}`
              : '',
            documentSize: document?.documentSizeinKB
              ? `${document?.documentSizeinKB}`
              : '',
            base64EncodedDoc: document?.documentBase64String
              ? `${document?.documentBase64String}`
              : '',
          };
        }),
    },
  };
};

function NewCustomerForm({
  validate,
  setLocalNewCustomerValues,
  setDropdownDetails,
  doSaveQuote,
  setEnableReinitialize,
  dataCustypeDomain,
  getDefaultClauses,
  getDefaultConditions,
  getDefaultWarranties,
  getDefaultExclusions,
  valuesAdditionalDetails,
  loadingSaveQuote,
  fireQuote,
  lobCode,
  productCode,
  selectedIntermediary,
  setCustomerNameQuoteSaved,
  setCustomerDetailsSaved,
}) {
  const { values, setFieldValue } = useQuantaFormikContext();
  const {
    loading,
    error,
    data: dropDownDetails,
  } = useQuery(CUSTOMER_DROPDOWN_DETAILS, {
    fetchPolicy: 'cache-first',
    onCompleted: (data) => setDropdownDetails(data),
  });


  const repeat = useResponsiveParams({
    for_mobile: 1,
    for_desktop: 4,
  });

  const isOpenedFromFragment = useResponsiveParams({
    for_mobile: true,
    for_desktop: false,
  });

  if (loading) {
    return (
      <div className="min-h-full">
        <Loading />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-full">
        <Error error={error} />
      </div>
    );
  }

  const newCustomerData = [
    {
      title: '',
      grid_data: [
        
        {
          type: 'select-tabs',
          name: 'customerType',
          colSpan: repeat,
          size: 'large',
          data: [
            fireQuote?.customerDetails?.customerType?.value ?.toString()
            ?.toLowerCase() === 'dwelling'
               
            ? 
            {
              icon: () => <FontAwesomeIcon icon={faUserTag} />,
              label: 'Individual',
              value: dataCustypeDomain?.customerTypeList
                ? getDomainData(
                    dataCustypeDomain?.customerTypeList,
                    'Individual',
                    'value',
                    'code',
                  )
                : '',
              onFieldChange: (values, _) => {
                // setEnableReinitialize(true);
                if (
                  values.customerType ===
                  getDomainData(
                    dataCustypeDomain?.customerTypeList,
                    'Organisation',
                    'value',
                    'code',
                  )
                ) {
                  Object.keys(values.orgDetails).forEach((k) => {
                    setFieldValue(`orgDetails.${k}`, '');
                  });
                  setLocalNewCustomerValues({
                    customerType: getDomainData(
                      dataCustypeDomain?.customerTypeList,
                      'Individual',
                      'value',
                      'code',
                    ),
                  });
                }
              },
            }:
            {
              icon: () => <FontAwesomeIcon icon={faBuilding} />,
              label: 'Organisation',
              value: dataCustypeDomain?.customerTypeList
                ? getDomainData(
                    dataCustypeDomain?.customerTypeList,
                    'Organisation',
                    'value',
                    'code',
                  )
                : '',
              onFieldChange: (values, _) => {
                setEnableReinitialize(false);
                if (
                  values.customerType ===
                  getDomainData(
                    dataCustypeDomain?.customerTypeList,
                    'Individual',
                    'value',
                    'code',
                  )
                ) {
                  Object.keys(values.indvDetails).forEach((k) => {
                    setFieldValue(`indvDetails.${k}`, '');
                  });
                  setLocalNewCustomerValues({
                    customerType: getDomainData(
                      dataCustypeDomain?.customerTypeList,
                      'Organisation',
                      'value',
                      'code',
                    ),
                  });
                }
              },
            },
          ],
        },
        // fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customerType?.value
        //     ?.toString()
        //     ?.toLowerCase() === 'dwelling'
        ...(fireQuote?.customerDetails?.customerType?.value ?.toString()
        ?.toLowerCase() === 'dwelling'
          ? [
              {
                type: 'select',
                name: 'indvDetails.title',
                label: (
                  <div>
                    Title <Text severity="error">*</Text>
                  </div>
                ),
                searchable: true,
                data: dropDownDetails?.salutationList
                  ? [
                      ...dropDownDetails.salutationList.map((s) => {
                        return {
                          label: s.value ? s.value : '',
                          value: s.code ? s.code : '',
                        };
                      }),
                    ]
                  : [],
              },
              {
                type: 'text',
                label: (
                  <div>
                    First Name <Text severity="error">*</Text>
                  </div>
                ),
                name: 'indvDetails.firstName',
                onKeyDown: (evt) => {
                  if (
                    (evt?.target?.value?.toString()?.endsWith(' ') &&
                      evt?.key === ' ') ||
                    (evt?.target?.value?.toString()?.length === 0 &&
                      evt?.key === ' ')
                  ) {
                    evt.preventDefault();
                  }
                },
              },
              {
                type: 'text',
                label: (
                  <div>
                    Middle Name <Text severity="error"></Text>
                  </div>
                ),
                name: 'indvDetails.middleName',
                onKeyDown: (evt) => {
                  if (
                    (evt?.target?.value?.toString()?.endsWith(' ') &&
                      evt?.key === ' ') ||
                    (evt?.target?.value?.toString()?.length === 0 &&
                      evt?.key === ' ')
                  ) {
                    evt.preventDefault();
                  }
                },
              },
              {
                type: 'text',
                label: (
                  <div>
                    Last Name <Text severity="error"></Text>
                  </div>
                ),
                name: 'indvDetails.lastName',
                onKeyDown: (evt) => {
                  if (
                    (evt?.target?.value?.toString()?.endsWith(' ') &&
                      evt?.key === ' ') ||
                    (evt?.target?.value?.toString()?.length === 0 &&
                      evt?.key === ' ')
                  ) {
                    evt.preventDefault();
                  }
                },
              },
              {
                type: 'email',
                label: (
                  <div>
                    Email Id <Text severity="error">*</Text>
                  </div>
                ),
                name: 'indvDetails.email',
              },
              {
              type: 'text',
              maxLength: 10,
                label: (
                  <div>
                    Mobile Number <Text severity="error">*</Text>
                  </div>
                ),
                name: 'indvDetails.mobileNumber',
              },
              {
                type: 'date',
                maxdate: moment()
                  .subtract(18, 'years')
                  .subtract(1, 'days')
                  .format('DD/MM/YYYY'),
                label: (
                  <div>
                    Date Of Birth <Text severity="error">*</Text>
                  </div>
                ),
                name: 'indvDetails.dob',
                calendarPosition: 'left',
                isOpenedFromFragment,
              },
            ]
          
          : [
              {
                type: 'text',
                label: (
                  <div>
                    Organisation Name <Text severity="error">*</Text>
                  </div>
                ),
                name: 'orgDetails.organisationName',
                onKeyDown: (evt) => {
                  if (
                    (evt?.target?.value?.toString()?.endsWith(' ') &&
                      evt?.key === ' ') ||
                    (evt?.target?.value?.toString()?.length === 0 &&
                      evt?.key === ' ')
                  ) {
                    evt.preventDefault();
                  }
                },
              },
              {
                type: 'select',
                label: (
                  <div>
                    Organisation Type <Text severity="error">*</Text>
                  </div>
                ),
                disableSelect: true,
                name: 'orgDetails.organisationType',
                data: dropDownDetails?.organisationList
                  ? [
                      ...dropDownDetails.organisationList.map(
                        (orgType) => {
                          return {
                            label: orgType.value ? orgType.value : '',
                            value: orgType.code ? orgType.code : '',
                          };
                        },
                      ),
                    ]
                  : [],
              },
              {
                type: 'text',
                maxLength: 40,
                label: (
                  <div>
                    Contact Person <Text severity="error"></Text>
                  </div>
                ),
                name: 'orgDetails.contactPerson',
                onKeyDown: (evt) => {
                  if (
                    (evt?.target?.value?.toString()?.endsWith(' ') &&
                      evt?.key === ' ') ||
                    (evt?.target?.value?.toString()?.length === 0 &&
                      evt?.key === ' ')
                  ) {
                    evt.preventDefault();
                  }
                },
              },
              {
              type: 'text',
              maxLength: 10,
                label: (
                  <div>
                    Mobile Number <Text severity="error">*</Text>
                  </div>
                ),
                name: 'orgDetails.mobileNumber',
              },
              {
                type: 'email',
                label: (
                  <div>
                    Email Id <Text severity="error">*</Text>
                  </div>
                ),
                name: 'orgDetails.email',
              },
            ]),
      ],
    },
  ];

  const other_props = {
    flow: 'cols',
    repeat,
    gapX: 6,
    gapY: 0,
    spaceY: 2,
    size: 'full',
    titleSeverity: 'info',
  };
  return (
    <QuantaForm className="space-y-4 h-full w-full">
      <div className="flex flex-col md:justify-between h-full pb-12">
        <div className="h-full">
          <InputGridGroup
            {...{ data: newCustomerData, ...other_props }}
          />
        </div>
        <div className="h-full flex flex-row justify-end items-end">
          <div>
            <Button
              flat={false}
              type="button"
              size="small"
              className="w-32"
              disabled={
                loadingSaveQuote
                  ? true
                  : values.customerType ===
                    getDomainData(
                      dataCustypeDomain?.customerTypeList,
                      'Individual',
                      'value',
                      'code',
                    )
                  ? Object.keys(validate(values).indvDetails)
                      .length !== 0
                  : Object.keys(validate(values).orgDetails)
                      .length !== 0
              }
              onClick={async (_) => {
                const customerData =
                  values.customerType ===
                  getDomainData(
                    dataCustypeDomain?.customerTypeList,
                    'Individual',
                    'value',
                    'code',
                  )
                    ? {
                        id: null,
                        customerType: values.customerType,
                        title: reformData(
                          values?.indvDetails?.title,
                          '',
                        ),
                        firstName: reformData(
                          values?.indvDetails?.firstName,
                          '',
                        ),
                        middleName: reformData(
                          values?.indvDetails?.middleName,
                          '',
                        ),
                        lastName: reformData(
                          values?.indvDetails?.lastName,
                          '',
                        ),
                        fullName: reformData(
                          [
                            values?.indvDetails?.title.trim(),
                            values?.indvDetails?.firstName.trim(),
                            values?.indvDetails?.middleName.trim(),
                            values?.indvDetails?.lastName.trim(),
                          ]
                            .filter((n) => n)
                            .join(' '),
                          '',
                        ),
                        emailID: reformData(
                          values?.indvDetails?.email,
                          '',
                        ),
                        mobileNo: reformData(
                          values?.indvDetails?.mobileNumber,
                          '',
                        ),
                        proposerDOB: reformData(
                          values?.indvDetails?.dob,
                          '',
                        ),
                        permCommAddressYN: false,
                      }
                    : {
                        id: null,
                        customerType: values.customerType,
                        orgName: reformData(
                          values?.orgDetails?.organisationName,
                          '',
                        ),
                        orgType: reformData(
                          values?.orgDetails?.organisationType,
                          '',
                        ),
                        contactName: reformData(
                          values?.orgDetails?.contactPerson,
                          '',
                        ),
                        mobileNo: reformData(
                          values?.orgDetails?.mobileNumber,
                          '',
                        ),
                        emailID: reformData(
                          values?.orgDetails?.email,
                          '',
                        ),
                        permCommAddressYN: false,
                      };
                const variables = saveQuoteVariables({
                  customer: customerData,
                  getDefaultClauses,
                  getDefaultConditions,
                  getDefaultExclusions,
                  getDefaultWarranties,
                  values: valuesAdditionalDetails,
                  fireQuote,
                  lobCode,
                  productCode,
                  selectedIntermediary,
                });
                setCustomerNameQuoteSaved(
                  values.customerType ===
                    getDomainData(
                      dataCustypeDomain?.customerTypeList,
                      'Individual',
                      'value',
                      'code',
                    )
                    ? `${values?.indvDetails?.title} ${
                        values?.indvDetails?.firstName
                      }${
                        values?.indvDetails?.middleName
                          ? ` ${values.indvDetails.middleName} `
                          : ' '
                      }${values?.indvDetails?.lastName}`
                    : values?.orgDetails?.organisationName,
                );
                setCustomerDetailsSaved(customerData);
                doSaveQuote({ variables });
              }}
              iconPre={
                <FontAwesomeIcon icon={faSave} className="ml-4" />
              }
            >
              <span className="pl-1 text-base">Save</span>
            </Button>
          </div>
        </div>
      </div>
    </QuantaForm>
  );
}

export default function ModalSaveQuote({
  modalSaveQuoteDisplay,
  onClose,
  values,
  getDefaultClauses,
  getDefaultConditions,
  getDefaultWarranties,
  getDefaultExclusions,
  goToStep,
  fireQuote,
  setAlerts,
  lobCode,
  productCode,
  selectedIntermediary,
  setButtonLabelCustomerTab,
  
}) {
const mutateQuery = useMutationQuery();
  const onModalClose = () => {
    setExistingCustomers([]);
    setLocalExistingCustomerValues({
      searchType: 'Mobile Number',
    });
    setEnableReinitialize(true);
    onClose();
    document.body.classList.remove('overflow-y-hidden');
  };

  const [customerNameSaved, setCustomerNameQuoteSaved] = useState('');
  const [customerDetailsSaved, setCustomerDetailsSaved] = useState();
  const { branding } = useContext(QuantaConfigContext);

  const icon_idle = (

    <img

      src={branding.illustration.no_data}

      alt="no data"

      className="lg:w-80 lg:h-80 w-64 h-64 opacity-50"

    />

  );
  const copyQuoteSaveLocationVariables = (data) => {
    try{
    return {
      input: {
        quoteNumber: data?.saveQuoteFireSA?.quoteNumber
          ? data?.saveQuoteFireSA?.quoteNumber
          : '',
          productName: fireQuote?.productKg, //productKg
          productCode: fireQuote?.productCode,
          basisOfValuation: fireQuote?.basisOfValuation,
        riskLocationID:
        fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskLocationID,
        occupancyCodeValue: {
          code: fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.occupancy
            ?.code,
          value:
          fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.occupancy
              ?.value,
          occupancySection:
          fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.occupancy
              ?.occupancySection,
          occupancyRate:
          fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.occupancy
              ?.occupancyRate,
          riskCode:
          fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.occupancy
              ?.riskCode,
          rateCode:
          fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.occupancy
              ?.rateCode,
          riskGrade:
          fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.occupancy
              ?.riskGrade,
          riskGradeDefinition:
          fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.occupancy
              ?.riskGradeDefinition,
          riskPreference:
          fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.occupancy
              ?.riskPreference,
          gicClass:
          fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.occupancy
              ?.gicClass,
          stfiRate:
          fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.occupancy
              ?.stfiRate,
          rsmdRate:
          fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.occupancy
              ?.rsmdRate,
        },
        riskLocAddress: {
          pinCode:
          fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails
              ?.pincode,
          state:
          fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails
              ?.state,
          city: fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails?.city,
          district:
          fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails
              ?.district,
          // eqZone:
          //   values?.riskLocations[riskLocationIndex]?.addressDetails
          //     ?.eqZone,
          addressLine1:
          fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails
              ?.addressLine1,
          locationCode:
          fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails
              ?.locationCode,
          isSamePremises: fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails?.isSamePremise
            ? true
            : false,
        },
        costOfConstruction:
            parseFloat(fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured
                ?.costOfConstruction),
            carpetArea:
            parseFloat(fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured
                ?.carpetArea),
            buildingValue:
            parseFloat(fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured
                ?.buildingValue),
            additionalStructure:
            parseFloat(fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured
                ?.additionalStructure),
            totalBuildingSI:
            parseFloat(fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured
                ?.totalBuildingSI),
            generalContentSI:
            parseFloat(fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock
                ?.generalContentSI),
            additionalContent:
            fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock
              ?.additionalContent,
          additionalContentSI:
            parseFloat(fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock
              ?.additionalContentSI),
            valuableContent:
            fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock
                ?.valuableContent,
            valuableContentSI:
            parseFloat(fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock
                ?.valuableContentSI),
          totalContentSI:
          parseFloat(fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock
                ?.totalContentSI),
            totalSumInsured:
            parseFloat(fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock
                ?.totalSumInsured),
          riskCovers: fireQuote?.riskcoverdata
          ? fireQuote?.riskcoverdata
           :[] ,
          ratePerMille: fireQuote?.riskcoverdata
            ?.find(
              (risk) => risk?.riskType === 'Cover Fire SA',
            )
            ?.covers?.map((cov) =>
              cov?.name === 'Basic Fire Cover'
                ? cov?.basicRate
                : 0,
            )
            // ?.filter((d: any) => d),
            ?.filter((d) => d)?.[0],
        // loadingPct:
        //   values?.riskLocations?.loadingAndDiscount
        //     ?.loadingPercentage,
        // discountPct:
        //   values?.riskLocations?.loadingAndDiscount
        //     ?.discountPercentage,
        // prevClaimExpDesc:
        //   values?.riskLocations[riskLocationIndex]
        //     ?.previousClaimDetails?.claimExperience,
        premium: {
          locNetPremium: fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.locationPremium?.locationNetPremium
            ? `${fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.locationPremium?.locationNetPremium}`
            : '',
          locGST: fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.locationPremium?.locationGST
            ? `${fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.locationPremium?.locationGST}`
            : '',
          locTotalPremium: fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.locationPremium?.locationTotalPremium
            ? `${fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.locationPremium?.locationTotalPremium}`
            : '',
          basicRate:fireQuote?.finalisedPremium?.basicRate
            || fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.locationPremium?.basicRate
        },
      },
    };
    }
    catch(error)
    {
   //   console.log('error copy quote save location variables',error)
    }
  }
  const copyQuoteSaveLocation = async (data) => {
    try{
    const saveLocationQuery = mutateQuery({
      mutation: SAVE_LOCATION_FIRE,
      variables: copyQuoteSaveLocationVariables(data),
    });
    const { data: saveLocationData } =
      await saveLocationQuery;
      if (
        saveLocationData?.saveLocationSA
          ?.successMsg
      ) {
        setAlerts([
          {
            id: parseInt(uuidv4()),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                <span>
                  {
                    saveLocationData
                      ?.saveLocationSA?.successMsg
                  }
                </span>
              </div>
            ),
            type: 'success',
            timeout: 3000,
            disableClose: false,
          },
        ]);
      } else if (
        saveLocationData?.saveLocationSA?.failMsg
      ) {
        setAlerts([
          {
            id: parseInt(uuidv4()),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                <span>
                  {
                    saveLocationData
                      ?.saveLocationSA?.failMsg
                  }
                </span>
              </div>
            ),
            type: 'error',
            timeout: null,
            disableClose: false,
          },
        ]);
      }
      return saveLocationData
    }
    catch (error) {
      setAlerts([
        {
          header: 'Error Saving Premium',
          id: parseInt(uuidv4()),
          content: (
            <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
              <span>{error?.message}</span>
            </div>
          ),
          type: 'error',
          timeout: null,
          disableClose: false,
        },
      ]);
      return error
    }
  }
  const [
    doSaveQuote,
    { loading: loadingSaveQuote, error: errorSaveQuote },
  ] = useMutation(SAVE_QUOTE_FIRE, {
    onCompleted: (data) => {
      let v = 'no data'
      if(data?.saveQuoteFireSA?.quoteNumber !== '' && fireQuote?.quoteNumber.toString() ==='' )
      {
         v = copyQuoteSaveLocation(data)
        
      }
      goToStep(3);
      if (
        data?.saveQuoteFireSA?.status?.toString()?.toLowerCase() ===
        'quote saved'
      ) {
        setAlerts([
          {
            id: Date.now() + Math.random(),
            content: (
              <Text>
                Quote submitted and saved successfully with customer
                name <br />{' '}
                <Text className={'font-semibold'}>
                  {customerNameSaved}
                </Text>
              </Text>
            ),
            timeout: 4000,
            type: 'success',
            disableClose: false,
          },
        ]);
      } else {
        setAlerts([
          {
            id: Date.now() + Math.random(),
            content: (
              <Text>
                Quote submitted with customer name <br />{' '}
                <Text className={'font-semibold'}>
                  {customerNameSaved}
                </Text>{' '}
                and is due for underwriter approval
              </Text>
            ),
            timeout: 4000,
            type: 'success',
            disableClose: false,
          },
        ]);
      }
      setButtonLabelCustomerTab('Proceed');
      updateFireQuote({
        tabDetails: {
          ...fireQuote?.tabDetails,
          customerTabDetails: {
            ...fireQuote?.tabDetails?.customerTabDetails,
            customerDetails: {
              ...fireQuote?.tabDetails?.customerTabDetails
                ?.customerDetails,
              customer: customerDetailsSaved,
              customerMeta: {
                crn: '',
                isNewCustomer: false,
                ifscCode: '',
                bankName: '',
                branchName: '',
                bankAcno: '',
                accountHolderName: '',
                micrCode: '',
              },
            },
          },
          additionalTabDetails: {
            ...fireQuote?.tabDetails?.additionalTabDetails,
            clauses: {
              ClauseCode:getDefaultClauses?.map(
                (clause) => clause?.clauseCode,
              )
                ? getDefaultClauses?.map(
                    (clause) => clause?.clauseCode,
                  )
                : [],
                ClauseNumber:getDefaultClauses?.map(
                  (clause) => clause?.clauseNumber,
                )
                  ? getDefaultClauses?.map(
                      (clause) => clause?.clauseNumber,
                    )
                  : [],
              Description:getDefaultClauses?.map(
                  (clause) => clause?.default,
                )
                  ? getDefaultClauses?.map(
                      (clause) => clause?.default,
                    )
                  : [],
              defaultClauses: getDefaultClauses?.map(
                (clause) => clause?.clauseDescription,
              )
                ? getDefaultClauses?.map(
                    (clause) => clause?.clauseDescription,
                  )
                : [],
              userDefinedClauses: values?.userDefinedClauses
                ?.filter((udc) => udc?.clause)
                ?.map((udc) => udc?.clause),
            },
            warranties: {
              WarrantyCode:getDefaultWarranties?.map(
                (warranty) => warranty?.warrantyCode,
              )
                ? getDefaultWarranties?.map(
                    (warranty) => warranty?.warrantyCode,
                  )
                : [],
              defaultWarranties: getDefaultWarranties?.map(
                (warranty) => warranty?.warrantyShortDescription,
              )
                ? getDefaultWarranties?.map(
                    (warranty) => warranty?.warrantyShortDescription,
                  )
                : [],
              WarrantyNumber:getDefaultWarranties?.map(
                (warranty) => warranty?.txtWarrantyNumber,
              )
                ? getDefaultWarranties?.map(
                    (warranty) => warranty?.txtWarrantyNumber,
                  )
                : [],
              Description:getDefaultWarranties?.map(
                (warranty) => warranty?.txtDefault,
              )
                ? getDefaultWarranties?.map(
                    (warranty) => warranty?.txtDefault,
                  )
                : [],
              userDefinedWarranties: values?.userDefinedWarranties
                ?.filter((udw) => udw?.warranty)
                ?.map((udw) => udw?.warranty),
            },
            exclusions: {
              ExclusionCode:getDefaultExclusions?.map(
                (exclusion) => exclusion?.exclusionCode,
              )
                ? getDefaultExclusions?.map(
                    (exclusion) => exclusion?.exclusionCode,
                  )
                : [],
                ExclusionNumber:getDefaultExclusions?.map(
                  (exclusion) => exclusion?.txtExclusionNumber,
                )
                  ? getDefaultExclusions?.map(
                      (exclusion) => exclusion?.txtExclusionNumber,
                    )
                : [],
              Description:getDefaultExclusions?.map(
                  (exclusion) => exclusion?.txtDefault,
                )
                  ? getDefaultExclusions?.map(
                      (exclusion) => exclusion?.txtDefault,
                    )
                  : [],
              defaultExclusions: getDefaultExclusions?.map(
                (exclusion) => exclusion?.exclusionShortDescription,
              )
                ? getDefaultExclusions?.map(
                    (exclusion) => exclusion?.exclusionShortDescription,
                  )
                : [],
              userDefinedExclusions: values?.userDefinedExclusions
                ?.filter((ude) => ude?.exclusion)
                ?.map((ude) => ude?.exclusion),
            },
            conditions: {
              ConditionCode:getDefaultConditions?.map(
                (condition) => condition?.conditionCode,
              )
                ? getDefaultConditions?.map(
                    (condition) => condition?.conditionCode,
                  )
                : [],
                ConditionNumber:getDefaultConditions?.map(
                  (condition) => condition?.txtConditionNumber,
                )
                  ? getDefaultConditions?.map(
                      (condition) => condition?.txtConditionNumber,
                    )
                : [],
              Description:getDefaultConditions?.map(
                  (condition) => condition?.txtDefault,
                )
                  ? getDefaultConditions?.map(
                      (condition) => condition?.txtDefault,
                    )
                  : [],
              defaultConditions: getDefaultConditions?.map(
                (condition) => condition?.conditionShortDescription,
              )
                ? getDefaultConditions?.map(
                    (condition) => condition?.conditionShortDescription,
                  )
                : [],
              userDefinedConditions: values?.userDefinedConditions
                ?.filter((udc) => udc?.condition)
                ?.map((udc) => udc?.condition),
            },
          },
        },
        quoteNumber: data?.saveQuoteFireSA?.quoteNumber
            ? `${data?.saveQuoteFireSA?.quoteNumber}`
            : '',
          quoteCreationDate: data?.saveQuoteFireSA?.quoteCreationDate
            ? `${data?.saveQuoteFireSA?.quoteCreationDate}`
            : '',
        status: data?.saveQuoteFireSA?.status,
        pendingMessage: data?.saveQuoteFireSA?.Msg?.toString(),
        currentTab: 3,
      });
      updateFireQuoteUploadDocsVar({
        documentDetails: values?.documentDetails,
      });
      onModalClose();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    onError: (_) => {},
  });

  const [
    localExistingCustomerValues,
    setLocalExistingCustomerValues,
  ] = useState({
    searchType: 'Mobile Number',
    customerType: 'Individual',
  });
  const [enableReinitialize, setEnableReinitialize] = useState(false);
  const [localNewCustomerValues, setLocalNewCustomerValues] =
    useState({});
  const fetchQuery = useFetchQuery();

  const [customerSearchMetaMessage, setCustomerSearchMetaMessage] =
    useState({ type: '', message: '' });

  const [isIdleDisplay, setIdleDisplay] = useState(true);
  const [existingCustomers, setExistingCustomers] = useState([]);
  const [loadingExistingCustomers, setLoadingExistingCustomers] =
    useState(false);
  const [customerDropdownDetails, setDropdownDetails] =
    useState(null);
  const [errors, setErrors] = useState({
    existingCustomers: '',
  });

  const modalSize = useResponsiveParams({
    for_mobile: 'full',
    for_desktop: 'large',
    for_iPad: 'full',
  });

  const tableRepeat = useResponsiveParams({
    for_mobile: 2,
    for_desktop: 3,
  });

  const screenType = useResponsiveParams({
    for_mobile: 'mobile',
    for_desktop: 'desktop',
  });

  const inputColSpans = useResponsiveParams({
    for_mobile: { searchString: 5, searchType: 3, button: 2 },
    for_desktop: { searchString: 3, searchType: 1, button: 1 },
  });

  const [
    getMobileNumberStartingWith,
    {
      loading: loadingMobileNumberStartingWith,
      error: errorMobileNumberStartingWith,
      data: dataMobileNumberStartingWith,
    },
  ] = useLazyQuery(MOBILE_NUMBER_STARTING_WITH, {
    fetchPolicy: 'cache-first',
  });

  const [
    getCharacterLimit,
    {
      loading: loadingCharacterLimit,
      error: errorCharacterLimit,
      data: dataCharacterLimit,
    },
  ] = useLazyQuery(CHARACTER_LIMIT_LIST, {
    fetchPolicy: 'cache-first',
  });

  const [
    getDataCustTypeDomain,
    {
      loading: loadingDataCustTypeDomain,
      error: errorDataCustDataTypeDomain,
      data: dataCustypeDomain,
    },
  ] = useLazyQuery(GET_CUSTOMER_TYPE_DOMAIN, {
    fetchPolicy: 'cache-first',
  });

  useEffect(() => {
    if (modalSaveQuoteDisplay) {
      getMobileNumberStartingWith();
      getCharacterLimit();
      getDataCustTypeDomain();
    }
  }, [modalSaveQuoteDisplay]);

  const getSearchTextPlaceholder = (searchType, customerType) => {
    switch (searchType) {
      case 'Customer Number':
        return 'Enter customer ID to search.';
      case 'Customer Name':
        //dom s
        return customerType ===
          getDomainData(
            dataCustypeDomain?.customerTypeList,
            'Individual',
            'value',
            'code',
          ) || !customerType
          ? 'Enter customer name to search.'
          : 'Enter organisation name to search.';
      case 'Mobile Number':
        return "Enter customer's mobile number to search.";
      default:
        return customerType ===
          getDomainData(
            dataCustypeDomain?.customerTypeList,
            'Individual',
            'value',
            'code',
          ) || !customerType
          ? "Enter customer's mobile number to search."
          : 'Enter organisation name to search.';
    }
  };

  const getSearchObject = (
    customerType,
    searchType,
    searchString,
  ) => {
    return {
      customer_type: customerType,
      customer_number:
        searchType === 'Customer Number' ? searchString : undefined,
      customer_name:
        searchType === 'Customer Name' ? searchString : undefined,
      mobile:
        searchType === 'Mobile Number' ? searchString : undefined,
    };
  };

  const validateNewCustomer = (values) => {
    const errors = {};
    if (
      values.customerType ===
      getDomainData(
        dataCustypeDomain?.customerTypeList,
        'Individual',
        'value',
        'code',
      )
    ) {
      errors.indvDetails = {};

      var mobileNumberValue =
        dataMobileNumberStartingWith?.mobileNumberStartingWith?.value;
      const firstNameValue =
        dataCharacterLimit?.characterLimitList?.find(
          (characterLimit) =>
            characterLimit.code.toLowerCase() === 'first name',
        );
      const middleNameValue =
        dataCharacterLimit?.characterLimitList?.find(
          (characterLimit) =>
            characterLimit.code.toLowerCase() === 'middle name',
        );
      const lastNameValue =
        dataCharacterLimit?.characterLimitList?.find(
          (characterLimit) =>
            characterLimit.code.toLowerCase() === 'last name',
        );

      if (!values.indvDetails.title) {
        errors.indvDetails.title = '* Required';
      }
      if (
        values.indvDetails.title &&
        customerDropdownDetails &&
        customerDropdownDetails.salutationList &&
        values.indvDetails.title !==
          getDomainData(
            customerDropdownDetails.salutationList,
            values.indvDetails.title,
            'value',
            'code',
          )
      ) {
        errors.indvDetails.title = '* Enter a valid title';
      } else if (
        customerDropdownDetails &&
        customerDropdownDetails.salutationList &&
        getDomainData(
          customerDropdownDetails?.salutationList,
          values?.indvDetails?.title,
          'code',
          'gender',
        )?.toLowerCase() &&
        values.indvDetails.gender?.toLowerCase() !==
          getDomainData(
            customerDropdownDetails?.salutationList,
            values?.indvDetails?.title,
            'code',
            'gender',
          )?.toLowerCase() &&
        (getDomainData(
          customerDropdownDetails?.genderList,
          values.indvDetails.gender,
          'code',
          'value',
        )?.toLowerCase() === 'male' ||
          getDomainData(
            customerDropdownDetails?.genderList,
            values.indvDetails.gender,
            'code',
            'value',
          )?.toLowerCase() === 'female')
      ) {
        errors.proposerDetails.title = '* Title mismatch with gender';
      }
      if (!values.indvDetails.firstName) {
        errors.indvDetails.firstName = '* Required';
      }
      if (
        values.indvDetails.firstName &&
        !values.indvDetails.firstName.match(/^[a-zA-Z ]*$/)
      ) {
        errors.indvDetails.firstName =
          '* First Name can contain alphabets only';
      }
      if (
        values.indvDetails.firstName &&
        values.indvDetails.firstName.length > firstNameValue?.value
      ) {
        errors.indvDetails.firstName = `* First Name cannot be greater than ${firstNameValue?.value} characters`;
      }
      if (
        values.indvDetails.middleName &&
        !values.indvDetails.middleName.match(/^[a-zA-Z ]*$/)
      ) {
        errors.indvDetails.middleName =
          '* Middle name can contain alphabets only';
      }
      if (
        values.indvDetails.middleName &&
        values.indvDetails.middleName.length > middleNameValue?.value
      ) {
        errors.indvDetails.middleName = `* Middle Name cannot be greater than ${middleNameValue?.value} characters`;
      }
      if (
        values.indvDetails.middleName &&
        !values.indvDetails.middleName.match(/\d/) &&
        !values.indvDetails.middleName.match(/^[a-zA-Z\s]+$/)
      ) {
        errors.indvDetails.middleName =
          '* No special characters allowed';
      }
      // if (!values.indvDetails.lastName) {
      //   errors.indvDetails.lastName = '* Required';
      // }
      if (
        values.indvDetails.lastName &&
        !values.indvDetails.lastName.match(/^[a-zA-Z. ]*$/)
      ) {
        errors.indvDetails.lastName =
          '* Last name can contain alphabets only';
      }
      if (
        values.indvDetails.lastName &&
        values.indvDetails.lastName.length > lastNameValue?.value
      ) {
        errors.indvDetails.lastName = `* Last Name cannot be greater than ${lastNameValue?.value} characters`;
      }
      if (!values.indvDetails.mobileNumber) {
        errors.indvDetails.mobileNumber = '* Required';
      }
      if (
        values.indvDetails.mobileNumber &&
        values.indvDetails.mobileNumber.toString().slice(0, 1) <
          mobileNumberValue
      ) {
        errors.indvDetails.mobileNumber = `* Mobile number must start with digit between ${mobileNumberValue} - 9`;
      }
      if (
        values.indvDetails.mobileNumber &&
        (values.indvDetails.mobileNumber.length !== 10 ||
          !values.indvDetails.mobileNumber.match(/^[0-9]+$/))
      ) {
        errors.indvDetails.mobileNumber =
          '* Mobile number must be of 10 digits';
      }
      if (!values.indvDetails.email) {
        errors.indvDetails.email = '* Required';
      }
      if (values.indvDetails.email) {
        let email_check = new RegExp(
          /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
        );
        if (!email_check.test(values.indvDetails.email)) {
          errors.indvDetails.email =
            '* Please enter valid email address';
        }
      }
      if (!values.indvDetails.dob) {
        errors.indvDetails.dob = '* Required';
      }
      if (values.indvDetails.dob) {
        if (moment(values.indvDetails.dob, 'DD/MM/YYYY').isAfter()) {
          errors.indvDetails.dob =
            '* Date of Birth cannot be a future date';
        }
      }
    } else {
      errors.orgDetails = {};

      var mobileNumberValue =
        dataMobileNumberStartingWith?.mobileNumberStartingWith?.value;

      const orgNameValue =
        dataCharacterLimit?.characterLimitList?.find(
          (characterLimit) =>
            characterLimit.code.toLowerCase() === 'org name',
        );

      if (!values.orgDetails.organisationName) {
        errors.orgDetails.organisationName = '* Required';
      }
      if (
        values.orgDetails.organisationName &&
        !values.orgDetails.organisationName.match(/^[a-zA-Z ]*$/)
      ) {
        errors.orgDetails.organisationName =
          '* Organisation name can contain alphabets only';
      }
      if (
        values.orgDetails.organisationName &&
        values.orgDetails.organisationName.length >
          orgNameValue?.value
      ) {
        errors.orgDetails.organisationName = `* Organisation Name cannot be greater than ${orgNameValue?.value} characters`;
      }
      if (!values.orgDetails.organisationType) {
        errors.orgDetails.organisationType = '* Required';
      }
      /**SU Divya : P2_928 -  Contact Person Name  as non-Mandatory*/
      // if (!values.orgDetails.contactPerson) {
      //   errors.orgDetails.contactPerson = '* Required';
      // }
      /**EU Divya : P2_928 -  Contact Person Name  as non-Mandatory*/
      if (
        values.orgDetails.contactPerson &&
        !values.orgDetails.contactPerson.match(/^[a-zA-Z ]*$/)
      ) {
        errors.orgDetails.contactPerson =
          '* Contact Person name can contain alphabets only';
      }
      if (!values.orgDetails.mobileNumber) {
        errors.orgDetails.mobileNumber = '* Required';
      }
      if (
        values.orgDetails.mobileNumber &&
        values.orgDetails.mobileNumber.toString().slice(0, 1) <
          mobileNumberValue
      ) {
        errors.orgDetails.mobileNumber = `* Mobile number must start with digit between ${mobileNumberValue} - 9`;
      }
      if (
        values.orgDetails.mobileNumber &&
        (values.orgDetails.mobileNumber.length !== 10 ||
          !values.orgDetails.mobileNumber.match(/^[0-9]+$/))
      ) {
        errors.orgDetails.mobileNumber =
          '* Mobile number must be of 10 digits';
      }
      if (!values.orgDetails.email) {
        errors.orgDetails.email = '* Required';
      }
      if (values.orgDetails.email) {
        let email_check = new RegExp(
          /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
        );
        if (!email_check.test(values.orgDetails.email)) {
          errors.orgDetails.email =
            '* Please enter valid email address';
        }
      }
    }
    return errors;
  };

  const initialValuesNewCustomer = {
    customerType: fireQuote?.customerDetails?.customerType?.value ?.toString()
    ?.toLowerCase() === 'dwelling'
      ? getDomainData(
          dataCustypeDomain?.customerTypeList,
          'Individual',
          'value',
          'code',
        )
      : getDomainData(
          dataCustypeDomain?.customerTypeList,
          'Organisation',
          'value',
          'code',
        ),
    indvDetails: {
      title: '',
      firstName: '',
      middleName: '',
      lastName: '',
      email: '',
      mobileNumber: '',
      dob: '',
    },
    orgDetails: {
      organisationName: '',
      organisationType: '',
      contactPerson: '',
      mobileNumber: '',
      email: '',
    },
  };
  
  // const initialValues = {
      
  //   customerType: localExistingCustomerValues?.customerType
  //     ? localExistingCustomerValues?.customerType
  //     : dataCustypeDomain?.customerTypeList /*&&  fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customerType?.value
  //     ?.toString()
  //     ?.toLowerCase() === 'dwelling'*/
  //     ? getDomainData(
  //         dataCustypeDomain?.customerTypeList,
  //         'Individual',
  //         'value',
  //         'code',
  //       )
  //     : getDomainData(
  //       dataCustypeDomain?.customerTypeList,
  //       'Organisation',
  //       'value',
  //       'code',
  //     ),
  //   searchString: localExistingCustomerValues?.searchString
  //     ? localExistingCustomerValues?.searchString
  //     : '',
  //   searchType: localExistingCustomerValues.searchType,
  // };
//customertype issue
  const searchInput = {
    enableReinitialize,
    flow: 'cols',
    repeat: 5,
    data: [
      {
        type: 'select-tabs',
        name: 'customerType',
        colSpan: 5,
        size: 'large',
        data: [
          // fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customerType?.value
          //   ?.toString()
          //   ?.toLowerCase() === 'dwelling'
          // ? 
          fireQuote?.customerDetails?.customerType?.value ?.toString()
            ?.toLowerCase() === 'dwelling'
            ?
          {
            icon: () => <FontAwesomeIcon icon={faUserTag} />,
            label: 'Individual',
            value: dataCustypeDomain?.customerTypeList
              ? getDomainData(
                  dataCustypeDomain?.customerTypeList,
                  'Individual',
                  'value',
                  'code',
                )
              : '',
            onFieldChange: (values, setFieldValue) => {
              setEnableReinitialize(false);
              if (
                values.customerType ===
                getDomainData(
                  dataCustypeDomain?.customerTypeList,
                  'Organisation',
                  'value',
                  'code',
                )
              ) {
                setFieldValue(
                  'customerType',
                  getDomainData(
                    dataCustypeDomain?.customerTypeList,
                    'Individual',
                    'value',
                    'code',
                  ),
                );
                setFieldValue('searchString', '');
                setFieldValue('searchType', 'Mobile Number');
                setLocalExistingCustomerValues({
                  ...localExistingCustomerValues,
                  customerType: getDomainData(
                    dataCustypeDomain?.customerTypeList,
                    'Individual',
                    'value',
                    'code',
                  ),
                  searchType: 'Mobile Number',
                });
                setExistingCustomers([]);
                setIdleDisplay(false);
              }
            },
          }:
          {
            icon: () => <FontAwesomeIcon icon={faBuilding} />,
            label: 'Organisation',
            value: dataCustypeDomain?.customerTypeList
              ? getDomainData(
                  dataCustypeDomain?.customerTypeList,
                  'Organisation',
                  'value',
                  'code',
                )
              : '',
            onFieldChange: (values, setFieldValue) => {
              setEnableReinitialize(true);
              if (
                values.customerType ===
                getDomainData(
                  dataCustypeDomain?.customerTypeList,
                  'Individual',
                  'value',
                  'code',
                )
              ) {
                setFieldValue(
                  'customerType',
                  getDomainData(
                    dataCustypeDomain?.customerTypeList,
                    'Organisation',
                    'value',
                    'code',
                  ),
                );
                setFieldValue('searchString', '');
                setFieldValue('searchType', '');
                setLocalExistingCustomerValues({
                  ...localExistingCustomerValues,
                  customerType: getDomainData(
                    dataCustypeDomain?.customerTypeList,
                    'Organisation',
                    'value',
                    'code',
                  ),
                  searchType: '',
                });
                setExistingCustomers([]);
                setIdleDisplay(true);
              }
            },
          },
        ],
      },
      {
        type:
          localExistingCustomerValues?.searchType
            ?.toString()
            .toLowerCase() === 'mobile number'
            ? 'number'
            : 'text',
        name: 'searchString',
        step:
          localExistingCustomerValues?.searchType
            ?.toString()
            .toLowerCase() === 'mobile number'
            ? '1'
            : null,
        min: 1000000000,
        max: 9999999999,
        size: 'full',
        onKeyDown: (evt) => {
          if (
            (evt.key === 'e' &&
              localExistingCustomerValues?.searchType
                ?.toString()
                .toLowerCase() === 'mobile number') ||
            (localExistingCustomerValues?.searchType
              ?.toString()
              .toLowerCase() === 'customer name' &&
              (!evt.key.match(/^[a-zA-Z ]+$/) ||
                (evt.target.value.length === 0 && evt.key === ' ') ||
                (evt.target.value.length > 0 &&
                  evt.target.value[evt.target.value.length - 1] ===
                    ' ' &&
                  evt.key === ' ')))
          ) {
            evt.preventDefault();
          }
        },
        placeholder: getSearchTextPlaceholder(
          localExistingCustomerValues?.searchType,
          localExistingCustomerValues?.customerType,
        ),
        onDataChange: (val, _) => {
          setLocalExistingCustomerValues({
            ...localExistingCustomerValues,
            searchString: val,
          });
          setEnableReinitialize(false);
        },
        colSpan: inputColSpans.searchString,
      },
      {
        type: 'select',
        name: 'searchType',
        size: 'full',
        className: 'flex flex-row justify-center items-center py-0',
        colSpan: inputColSpans.searchType,
        value: localExistingCustomerValues.searchType,
        onDataChange: (val, _) => {
          setLocalExistingCustomerValues({
            ...localExistingCustomerValues,
            searchType: val,
          });
          setEnableReinitialize(false);
        },
        data:
     
        //   fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customerType?.value
        // ?.toString()
        // ?.toLowerCase() === 'dwelling' &&
          
          fireQuote?.customerDetails?.customerType?.value?.toString()
          ?.toLowerCase() === 'dwelling'
            ? [
              
              { label: 'Customer ID', value: 'Customer Number' },
              { label: 'Mobile Number', value: 'Mobile Number' },
            ]
            : [
              
              { label: 'Customer ID', value: 'Customer Number' },
              { label: 'Mobile Number', value: 'Mobile Number' },
            ],
      },
      {
        type: 'submit',
        colSpan: inputColSpans.button,
        iconPre: <FontAwesomeIcon icon={faSearch} />,
        children: 'Search',
        size: 'full',
      },
    ],
     initialValues : {
      
      customerType: localExistingCustomerValues?.customerType
        ? localExistingCustomerValues?.customerType
        : dataCustypeDomain?.customerTypeList /*&&  fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customerType?.value
        ?.toString()
        ?.toLowerCase() === 'dwelling'*/
        ? getDomainData(
            dataCustypeDomain?.customerTypeList,
            'Individual',
            'value',
            'code',
          )
        : getDomainData(
          dataCustypeDomain?.customerTypeList,
          'Organisation',
          'value',
          'code',
        ),
      searchString: localExistingCustomerValues?.searchString
        ? localExistingCustomerValues?.searchString
        : '',
      searchType: localExistingCustomerValues.searchType,
    },
   
    validate: (values) => {
      const errors = {};

      var mobileNumberCode =
        dataMobileNumberStartingWith?.mobileNumberStartingWith?.code;
      var mobileNumberValue =
        dataMobileNumberStartingWith?.mobileNumberStartingWith?.value;

      const orgNameValue =
        dataCharacterLimit?.characterLimitList?.find(
          (characterLimit) =>
            characterLimit?.code?.toLowerCase() === 'org name',
        );

      if (!values.customerType || values.customerType === '') {
        errors.customerType = '* Required';
      } else if (!values.searchString || values.searchString === '') {
        errors.searchString = '* Required';
      } else if (
        values.customerType ===
          getDomainData(
            dataCustypeDomain.customerTypeList,
            'Individual',
            'value',
            'code',
          ) &&
        typeof values.searchString === 'string' &&
        ((values.searchString.toLowerCase().startsWith('mrs') &&
          values.searchString.length < 6) ||
          (values.searchString.toLowerCase().startsWith('mr') &&
            values.searchString.length < 5) ||
          (values.searchString.toLowerCase().startsWith('dr') &&
            values.searchString.length < 5) ||
          (values.searchString.toLowerCase().startsWith('miss') &&
            values.searchString.length < 7))
      ) {
        errors.searchString =
          '* Customer cannot be searched only by title';
      } else if (
        values.customerType ===
          getDomainData(
            dataCustypeDomain.customerTypeList,
            'Individual',
            'value',
            'code',
          ) &&
        values.searchString.length < 4 &&
        values.searchType.toLowerCase() !== 'mobile number'
      ) {
        errors.searchString =
          '* Minimum 4 characters are required for individual customer search';
      } else if (
        dataCustypeDomain &&
        dataCustypeDomain.customerTypeList &&
        values.customerType ===
          getDomainData(
            dataCustypeDomain.customerTypeList,
            'Organisation',
            'value',
            'code',
          ) &&
        values.searchString.length < 3
      ) {
        errors.searchString =
          '* Minimum 3 characters are required for organisation/corporate customer search';
      } else if (
        dataCustypeDomain &&
        dataCustypeDomain.customerTypeList &&
        values.customerType ===
          getDomainData(
            dataCustypeDomain.customerTypeList,
            'Organisation',
            'value',
            'code',
          ) &&
        values.searchType.toLowerCase().endsWith('name') &&
        values.searchString.length > orgNameValue?.value
      ) {
        errors.searchString = `* Organisation Name cannot be greater than ${orgNameValue.value} characters`;
      } else if (
        dataCustypeDomain.customerTypeList &&
        values.customerType ===
          getDomainData(
            dataCustypeDomain.customerTypeList,
            'Organisation',
            'value',
            'code',
          ) &&
        values.searchType.toLowerCase().endsWith('name') &&
        !values.searchString.match(/^[a-zA-Z ]+$/)
      ) {
        errors.searchString =
          '* Organisation name contains only alphabets';
      } else if (
        values.customerType ===
          getDomainData(
            dataCustypeDomain.customerTypeList,
            'Individual',
            'value',
            'code',
          ) &&
        values.searchType.toLowerCase().endsWith('name') &&
        values.searchString.match(/\d/)
      ) {
        errors.searchString =
          '* Customer name cannot be alphanumeric';
      } else if (
        values.customerType ===
          getDomainData(
            dataCustypeDomain.customerTypeList,
            'Individual',
            'value',
            'code',
          ) &&
        values.searchType.toLowerCase().endsWith('name') &&
        !values.searchString.match(/^[a-zA-Z ]+$/)
      ) {
        errors.searchString =
          '* Customer name contains only alphabets';
      } else if (
        values.searchType.toLowerCase() ===
          mobileNumberCode.toLowerCase() &&
        values.searchString.toString().slice(0, 1) < mobileNumberValue
      ) {
        errors.searchString = `* Mobile number must start with digit between ${mobileNumberValue} - 9`;
      } else if (
        values.searchType.toLowerCase() === 'mobile number' &&
        (values.searchString.toString().length !== 10 ||
          !values.searchString.toString().match(/^[0-9]+$/))
      ) {
        errors.searchString = '* Mobile number must be of 10 digits';
      } else if (!values.searchType || values.searchType === '') {
        errors.searchType = '* Required';
      } else if (
        values?.searchType?.toString()?.toLowerCase() ===
          'customer number' &&
        !values?.searchString?.match(/^[a-zA-Z0-9]+$/)
      ) {
        errors.searchString =
          '* Customer ID cannot contain special characters';
      }
      return errors;
    },
    onSearch: async (values) => {
      const { searchType, customerType, searchString } = values;
      setIdleDisplay(false);
      try {
        setExistingCustomers([]);
        setLoadingExistingCustomers(true);

        let queryOutput = fetchQuery({
          query: SEARCH_CUSTOMERS,
          variables: {
            filter: getSearchObject(
              customerType,
              searchType,
              searchString,
            ),
          },
        });
        let { data } = await queryOutput;
        setLoadingExistingCustomers(false);
        setExistingCustomers(data.customers);
        setCustomerSearchMetaMessage({
          type: data._customer_meta.metaMessage.type,
          message: data._customer_meta.metaMessage.message,
        });
      } catch (error) {
        setErrors({
          ...errors,
          existingCustomers: error.message,
        });
        setLoadingExistingCustomers(false);
        setExistingCustomers([]);
      }
    },
  };

  const searchResults = {
    data: existingCustomers,
    onIdle: () => {
      if (loadingExistingCustomers) {
        return <Loading />;
      } else if (isIdleDisplay) {
        return icon_idle;
      }
      return undefined;
    },
    dependencies: [
      localExistingCustomerValues?.customerType,
      localExistingCustomerValues?.searchString,
    ],
    columns: [
      {
        Header: 'Customer ID',
        accessor: 'cust_number',
      },
      {
        Header:
          !localExistingCustomerValues.customerType ||
          localExistingCustomerValues.customerType ===
            getDomainData(
              dataCustypeDomain?.customerTypeList,
              'Individual',
              'value',
              'code',
            )
            ? 'Customer Name'
            : 'Organisation Name',
        Cell: ({ row }) => (
          <span>
            {row.original.cust_type.value ===
            getDomainData(
              dataCustypeDomain?.customerTypeList,
              'Individual',
              'value',
              'code',
            )
              ? row.original.indv_detail.full_name
              : row.original.org_detail.org_name}
          </span>
        ),
      },
      {
        Header: 'Location',
        Cell: ({ row }) => {
          return (
            <div className="text-base">
              {row.original.permanent_address.location}
            </div>
          );
        },
      },
      {
        Header: 'Contact',
        Cell: ({ row }) => {
          return (
            <span>
              <div className="flex flex-col -mb-1 -mt-1 item-baseline justify-center">
                <div className="text-base">
                  {row.original.contact.mobile}
                </div>
                <div className="text-base">
                  {row.original.contact.email}
                </div>
              </div>
            </span>
          );
        },
      },
    ].filter((d) => d.Header !== undefined),
    grid: {
      repeat: 1,
      gap: 2,
      gapX: 2,
      gapY: 2,
      gridClassName: 'w-full',
      gridItemsArr:
        existingCustomers.length > 0
          ? existingCustomers?.map((customerData) => {
              return {
                id: `${customerData?.cust_number}`,
                content: (
                  <Paper
                    className={`border-2 rounded cursor-pointer p-4 h-full hover:bg-neutral-light`}
                  >
                    <Text
                      className={
                        'flex flex-col h-full w-full justify-between'
                      }
                    >
                      <Text
                        className={
                          'flex items-center justify-between'
                        }
                      >
                        <Text
                          className={
                            'font-semibold flex space-x-4 items-start'
                          }
                        >
                          <Text
                            className={
                              'flex flex-col justify-start items-center'
                            }
                          >
                            <Text
                              severity={'info'}
                              className="border-2 px-2 py-1 rounded-lg bg-white"
                            >
                              
                              {customerData?.cust_type?.value
                                ?.toString()
                                ?.toLowerCase() === 'organisation' ? (
                                <FontAwesomeIcon
                                  icon={faUniversity}
                                  size={'2x'}
                                />
                              ) : (
                                <FontAwesomeIcon
                                  icon={faUser}
                                  size={'2x'}
                                />
                              )}
                            </Text>
                          </Text>
                          <Text className={'flex flex-col'}>
                            <Text
                              severity={'info'}
                              className={'font-semibold'}
                            >
                              {`${
                                customerData.cust_type.value ===
                                'Individual'
                                  ? customerData.indv_detail.full_name
                                  : customerData.org_detail.org_name
                              }`}
                            </Text>
                            <Text
                              severity={'neutral-darker'}
                              type={'label'}
                            >
                              {customerData.cust_number}
                            </Text>
                          </Text>
                        </Text>
                      </Text>
                      <Grid repeat={3} className={'w-full'}>
                        {customerData.permanent_address.location ? (
                          <GridItem
                            colSpan={1}
                            className={
                              screenType === 'desktop'
                                ? 'flex space-x-2 w-full justify-start ml-16 mt-2'
                                : 'flex space-x-2 w-full justify-start ml-2 mt-2'
                            }
                          >
                            <Text>
                              <FontAwesomeIcon
                                icon={faMapMarkerAlt}
                              />
                            </Text>
                            <Text>
                              {
                                customerData.permanent_address
                                  .location
                              }
                            </Text>
                          </GridItem>
                        ) : (
                          <GridItem colSpan={1}>
                            <></>
                          </GridItem>
                        )}
                        {customerData.contact.mobile ? (
                          <GridItem
                            colSpan={1}
                            className={
                              screenType === 'desktop'
                                ? 'flex justify-center space-x-2 w-full mt-2'
                                : 'flex space-x-2 w-full mt-2'
                            }
                          >
                            <Text>
                              <FontAwesomeIcon icon={faMobileAlt} />
                            </Text>
                            <Text>{customerData.contact.mobile}</Text>
                          </GridItem>
                        ) : (
                          <GridItem colSpan={1}>
                            <></>
                          </GridItem>
                        )}
                        {customerData.contact.email ? (
                          <GridItem
                            colSpan={1}
                            className={
                              screenType === 'desktop'
                                ? 'flex space-x-2 w-full mt-2 ml-7'
                                : 'flex space-x-2 w-full mt-2'
                            }
                          >
                            <Text>
                              <FontAwesomeIcon icon={faEnvelope} />
                            </Text>
                            <Text>{customerData.contact.email}</Text>
                          </GridItem>
                        ) : (
                          <GridItem colSpan={1}>
                            <></>
                          </GridItem>
                        )}
                      </Grid>
                    </Text>
                  </Paper>
                ),
                onClick: async () => {
                  let customerDataModified =
                    customerData?.cust_type?.value ===
                    getDomainData(
                      dataCustypeDomain?.customerTypeList,
                      'Individual',
                      'value',
                      'code',
                    )
                      ? {
                          id: customerData?.cust_number,
                          customerType: customerData?.cust_type?.code,
                          title: reformData(
                            customerData?.indv_detail?.title?.code,
                            '',
                          ),
                          firstName: reformData(
                            customerData?.indv_detail?.first_name,
                            '',
                          ),
                          middleName: reformData(
                            customerData?.indv_detail?.middle_name,
                            '',
                          ),
                          fullName: reformData(
                            customerData?.indv_detail?.full_name,
                            '',
                          ),
                          lastName: reformData(
                            customerData?.indv_detail?.surname,
                            '',
                          ),
                          emailID: reformData(
                            customerData?.contact?.email,
                            '',
                          ),
                          mobileNo: reformData(
                            customerData?.contact?.mobile,
                            '',
                          ),
                          proposerDOB: reformData(
                            customerData?.indv_detail?.date_of_birth,
                            '',
                          ),
                        }
                      : {
                          id: customerData?.cust_number,
                          customerType: customerData?.cust_type?.code,
                          orgName: reformData(
                            customerData?.org_detail?.org_name,
                            '',
                          ),
                          orgType: reformData(
                            customerData?.org_detail?.org_type?.code,
                            '',
                          ),
                          contactName: reformData(
                            customerData?.org_detail?.contact_name,
                            '',
                          ),
                          mobileNo: reformData(
                            customerData?.contact?.mobile,
                            '',
                          ),
                          emailID: reformData(
                            customerData?.contact?.email,
                            '',
                          ),
                        };
                  setCustomerNameQuoteSaved(
                    customerData?.cust_type?.value ===
                      getDomainData(
                        dataCustypeDomain?.customerTypeList,
                        'Individual',
                        'value',
                        'code',
                      )
                      ? customerData?.indv_detail?.full_name
                      : customerData?.org_detail?.org_name,
                  );
                  setCustomerDetailsSaved(customerDataModified);
                  const variables = saveQuoteVariables({
                    customer: customerDataModified,
                    getDefaultClauses,
                    getDefaultConditions,
                    getDefaultExclusions,
                    getDefaultWarranties,
                    values,
                    fireQuote,
                    lobCode,
                    productCode,
                    selectedIntermediary,
                  });
                  doSaveQuote({ variables });
                },
                colSpan: 1,
              };
            })
          : [],
    },
    card: {
      gap: 2,
      gapX: 2,
      gapY: 2,
      cardClassName: 'w-full',
      cardItemsArr:
        existingCustomers.length > 0
          ? existingCustomers?.map((customerData) => {
              return {
                id: `${customerData?.cust_number}`,
                content: (
                  <Paper
                    className={` border-2 rounded cursor-pointer p-4 h-full hover:bg-neutral-light`}
                  >
                    <Text
                      className={
                        'flex flex-col h-full w-full justify-start'
                      }
                    >
                      <Text
                        className={
                          'flex items-center justify-between'
                        }
                      >
                        <Text
                          className={
                            'font-semibold flex space-x-2 items-start'
                          }
                        >
                          <Text className={'flex flex-col'}>
                            <Text
                              severity={'info'}
                              className={'font-semibold'}
                            >
                              {`${
                                customerData.cust_type.value ===
                                'Individual'
                                  ? customerData.indv_detail.full_name
                                  : customerData.org_detail.org_name
                              }`}
                            </Text>
                            <Text
                              severity={'neutral-darker'}
                              type={'label'}
                            >
                              {customerData.cust_number}
                            </Text>
                          </Text>
                        </Text>
                      </Text>
                      <Grid
                        repeat={2}
                        gap={1}
                        className={'w-full h-full mt-2'}
                      >
                        {customerData.permanent_address.location ? (
                          <GridItem
                            colSpan={1}
                            className={
                              'flex space-x-2 w-full justify-start items-center'
                            }
                          >
                            <Text type={'label'}>
                              <FontAwesomeIcon
                                icon={faMapMarkerAlt}
                              />
                            </Text>
                            <Text type={'label'}>
                              {
                                customerData.permanent_address
                                  .location
                              }
                            </Text>
                          </GridItem>
                        ) : (
                          <GridItem colSpan={1}>
                            <></>
                          </GridItem>
                        )}
                        {customerData.contact.mobile ? (
                          <GridItem
                            colSpan={1}
                            className={
                              screenType === 'mobile'
                                ? 'flex space-x-2 w-full justify-end'
                                : 'flex space-x-2 w-full justify-start'
                            }
                          >
                            <Text type={'label'}>
                              <FontAwesomeIcon icon={faMobileAlt} />
                            </Text>
                            <Text type={'label'}>
                              {customerData.contact.mobile}
                            </Text>
                          </GridItem>
                        ) : (
                          <GridItem colSpan={1}>
                            <></>
                          </GridItem>
                        )}
                        {customerData.contact.email ? (
                          <GridItem
                            colSpan={1}
                            className={
                              'flex space-x-2 w-full items-center'
                            }
                          >
                            <Text type={'label'}>
                              <FontAwesomeIcon icon={faEnvelope} />
                            </Text>
                            <Text type={'label'}>
                              {customerData.contact.email}
                            </Text>
                          </GridItem>
                        ) : (
                          <GridItem colSpan={1}>
                            <></>
                          </GridItem>
                        )}
                      </Grid>
                    </Text>
                  </Paper>
                ),
                onClick: async () => {
                  let customerDataModified =
                    customerData?.cust_type?.value ===
                    getDomainData(
                      dataCustypeDomain?.customerTypeList,
                      'Individual',
                      'value',
                      'code',
                    )
                      ? {
                          id: customerData?.cust_number,
                          customerType: customerData?.cust_type?.code,
                          title: reformData(
                            customerData?.indv_detail?.title?.code,
                            '',
                          ),
                          firstName: reformData(
                            customerData?.indv_detail?.first_name,
                            '',
                          ),
                          middleName: reformData(
                            customerData?.indv_detail?.middle_name,
                            '',
                          ),
                          fullName: reformData(
                            customerData?.indv_detail?.full_name,
                            '',
                          ),
                          lastName: reformData(
                            customerData?.indv_detail?.surname,
                            '',
                          ),
                          emailID: reformData(
                            customerData?.contact?.email,
                            '',
                          ),
                          mobileNo: reformData(
                            customerData?.contact?.mobile,
                            '',
                          ),
                          proposerDOB: reformData(
                            customerData?.indv_detail?.date_of_birth,
                            '',
                          ),
                        }
                      : {
                          id: customerData?.cust_number,
                          customerType: customerData?.cust_type?.code,
                          orgName: reformData(
                            customerData?.org_detail?.org_name,
                            '',
                          ),
                          orgType: reformData(
                            customerData?.org_detail?.org_type?.code,
                            '',
                          ),
                          contactName: reformData(
                            customerData?.org_detail?.contact_name,
                            '',
                          ),
                          mobileNo: reformData(
                            customerData?.contact?.mobile,
                            '',
                          ),
                          emailID: reformData(
                            customerData?.contact?.email,
                            '',
                          ),
                        };
                  setCustomerNameQuoteSaved(
                    customerData?.cust_type?.value ===
                      getDomainData(
                        dataCustypeDomain?.customerTypeList,
                        'Individual',
                        'value',
                        'code',
                      )
                      ? customerData?.indv_detail?.full_name
                      : customerData?.org_detail?.org_name,
                  );
                  setCustomerDetailsSaved(customerDataModified);
                  const variables = saveQuoteVariables({
                    customer: customerDataModified,
                    getDefaultClauses,
                    getDefaultConditions,
                    getDefaultExclusions,
                    getDefaultWarranties,
                    values,
                    fireQuote,
                    lobCode,
                    productCode,
                    selectedIntermediary,
                  });
                  doSaveQuote({ variables });
                },
                colSpan: 1,
              };
            })
          : [],
    },
    onRowClick: async (customerData) => {
      let customerDataModified =
        customerData?.cust_type?.value ===
        getDomainData(
          dataCustypeDomain?.customerTypeList,
          'Individual',
          'value',
          'code',
        )
          ? {
              id: customerData?.cust_number,
              customerType: customerData?.cust_type?.code,
              title: reformData(
                customerData?.indv_detail?.title?.code,
                '',
              ),
              firstName: reformData(
                customerData?.indv_detail?.first_name,
                '',
              ),
              middleName: reformData(
                customerData?.indv_detail?.middle_name,
                '',
              ),
              fullName: reformData(
                customerData?.indv_detail?.full_name,
                '',
              ),
              lastName: reformData(
                customerData?.indv_detail?.surname,
                '',
              ),
              emailID: reformData(customerData?.contact?.email, ''),
              mobileNo: reformData(customerData?.contact?.mobile, ''),
              proposerDOB: reformData(
                customerData?.indv_detail?.date_of_birth,
                '',
              ),
            }
          : {
              id: customerData?.cust_number,
              customerType: customerData?.cust_type?.code,
              orgName: reformData(
                customerData?.org_detail?.org_name,
                '',
              ),
              orgType: reformData(
                customerData?.org_detail?.org_type?.code,
                '',
              ),
              contactName: reformData(
                customerData?.org_detail?.contact_name,
                '',
              ),
              mobileNo: reformData(customerData?.contact?.mobile, ''),
              emailID: reformData(customerData?.contact?.email, ''),
            };
      setCustomerNameQuoteSaved(
        customerData?.cust_type?.value ===
          getDomainData(
            dataCustypeDomain?.customerTypeList,
            'Individual',
            'value',
            'code',
          )
          ? customerData?.indv_detail?.full_name
          : customerData?.org_detail?.org_name,
      );
      setCustomerDetailsSaved(customerDataModified);
      const variables = saveQuoteVariables({
        customer: customerDataModified,
        getDefaultClauses,
        getDefaultConditions,
        getDefaultExclusions,
        getDefaultWarranties,
        values,
        fireQuote,
        lobCode,
        productCode,
        selectedIntermediary,
      });
      doSaveQuote({ variables });
    },
    sortBy: { id: 'cust_number', desc: false },
  };

  const paginationInput = {
    offset: 0,
    PAGE_SIZE: 4,
  };

  const onNoResultsFound = () => {
    return errors.existingCustomers;
  };

  const onMessage = () => {
    return (
      customerSearchMetaMessage &&
      customerSearchMetaMessage.type &&
      customerSearchMetaMessage.message && (
        <Text
          severity={customerSearchMetaMessage.type}
          className="space-x-1"
        >
          <div className="flex flex-row">
            <div>
              <FontAwesomeIcon
                icon={
                  customerSearchMetaMessage.type === 'info'
                    ? faExclamationCircle
                    : customerSearchMetaMessage.type === 'warning'
                    ? faExclamationTriangle
                    : faTimesCircle
                }
                className={`mr-1 text-${customerSearchMetaMessage.type}`}
              />
            </div>
            <div>{customerSearchMetaMessage.message}</div>
          </div>
        </Text>
      )
    );
  };

  const renderTabData = [
    {
      icon: <FontAwesomeIcon icon={faUserCheck} />,
      label: 'Existing Customer',
      onTabClick: () => {
        setEnableReinitialize(false);
      },
      tab_data: (

        <div className="flex flex-col justify-between h-full">

          <div> 

            <SearchResultsAdvanced

              {...{

                searchInput,

                searchResults,

                paginationInput,

                onMessage,

                onNoResultsFound,

                isModalDisplay: true,

                firstRowClickRequired: false,

                switchViewEnabled: true,

              }}

            />

         

          </div>

        </div>

      ),
    },
    {
      icon: <FontAwesomeIcon icon={faUserPlus} />,
      label: 'New Customer',
      onTabClick: () => {
        setEnableReinitialize(false);
      },
      tab_data: (
        <QuantaFormik
          {...{
            initialValues: initialValuesNewCustomer,
            validate: validateNewCustomer,
            enableReinitialize: true,
          }}
        >
          <NewCustomerForm
            {...{
              validate: validateNewCustomer,
              setLocalNewCustomerValues,
              setDropdownDetails,
              doSaveQuote,
              setEnableReinitialize,
              dataCustypeDomain,
              getDefaultClauses,
              getDefaultConditions,
              getDefaultWarranties,
              getDefaultExclusions,
              valuesAdditionalDetails: values,
              loadingSaveQuote,
              fireQuote,
              lobCode,
              productCode,
              selectedIntermediary,
              setCustomerNameQuoteSaved,
              setCustomerDetailsSaved,
            }}
          />
        </QuantaFormik>
      ),
    },
  ];

  return (
    <Modal
      size={modalSize}
      display={modalSaveQuoteDisplay}
      severity="action"
      title={'Save Customer Details'}
      onClose={(_) => {
        onModalClose();
      }}
      className="h-screen flex flex-col justify-start"
    >
      {(loadingCharacterLimit ||
        loadingMobileNumberStartingWith ||
        loadingDataCustTypeDomain ||
        loadingSaveQuote) && (
        <div className="h-full w-full">
          <Loading
            customMessage={
              loadingSaveQuote ? 'Saving Quote' : undefined
            }
          />
        </div>
      )}
      {(errorCharacterLimit ||
        errorMobileNumberStartingWith ||
        errorDataCustDataTypeDomain ||
        errorSaveQuote) && (
        <div className="h-full w-full">
          <Error
            error={
              errorCharacterLimit ||
              errorMobileNumberStartingWith ||
              errorDataCustDataTypeDomain ||
              errorSaveQuote
            }
          />
        </div>
      )}
      {!loadingMobileNumberStartingWith &&
        !loadingCharacterLimit &&
        !errorMobileNumberStartingWith &&
        !errorCharacterLimit &&
        !loadingDataCustTypeDomain &&
        !errorDataCustDataTypeDomain &&
        !loadingSaveQuote &&
        !errorSaveQuote && (
          <MixedTabbedDataGroup
            data={renderTabData}
            textType="normal"
            titleSeverity="info"
            repeat={tableRepeat}
            nullData={() => (
              <Text severity="neutral">Not Captured</Text>
            )}
          />
        )}
    </Modal>
  );
}
